import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../Api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [user, setUser] = useState(null);
  const [isAuth, setAuthStatus] = useState(false);
  const [loading, setLoading] = useState(true); // Состояние для отслеживания загрузки

  // Проверка токена при его изменении
  useEffect(() => {
    if (token) {
      checkToken();  // Проверяем токен, если он есть
    } else {
      setLoading(false);  // Если токена нет, прекращаем загрузку
    }
  }, [token]);

  // Навигация на основе статуса аутентификации
  useEffect(() => {
    if (loading) return;  // Не делать навигацию, пока идет загрузка
    if (!isAuth) {
      navigate("/auth");  // Если не аутентифицирован, направляем на страницу авторизации
    }
  }, [isAuth, loading, navigate]);

  // Логин
  const login = async (email, password) => {
    try {
      const response = await authAPI.login({ email, password });
      const data = response.data;

      if (data.token) {
        localStorage.setItem("token", data.token);
        setToken(data.token);
        setUser(data.user);
        setAuthStatus(true);
        setLoading(false); // После логина данные загружены, ставим состояние загрузки в false
        console.log(data);
      } else {
        throw new Error("Ошибка авторизации");
      }
    } catch (error) {
      console.error(error);
      setLoading(false); // В случае ошибки также завершаем загрузку
    }
  };

  // Проверка токена на сервере
  const checkToken = async () => {
    try {
      const response = await authAPI.checkToken();
      if (response.data.status) {
        // Токен действителен
        // сервер возвращает { status: true, data: user }
        // токен не возвращается, поэтому не перезаписываем существующий
        setUser(response.data.data);
        setAuthStatus(true);
      } else {
        // Если токен невалиден, удаляем его
        logout();
      }
      setLoading(false); // Завершаем загрузку после проверки токена
      return response.data.status;
    } catch (error) {
      console.error("Ошибка проверки токена", error);
      logout();  // В случае ошибки проверяем, чтобы выйти
      setLoading(false); // Завершаем загрузку в случае ошибки
      return false;
    }
  };

  // Логаут
  const logout = () => {
    localStorage.removeItem("token");  // Убираем токен из localStorage
    setToken(null);  // Очищаем состояние токена
    setUser(null);  // Очищаем данные пользователя
    setAuthStatus(false);  // Сбрасываем статус аутентификации
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, checkToken, isAuth }}>
      {!loading && children} {/* Показываем дочерние компоненты только после завершения загрузки */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
